module.exports = __webpack_public_path__ + "static/media/notifications-button.09c8e43c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/notifications-button.svg
// module id = 1185
// module chunks = 0